package floris.graphics.models.dto.requests.techstack

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UpdateTechstack(
    val name: String = "",
    @SerialName("parent_techstack_id")
    val parentTechstackId: String? = null
) {
    // With the update, both the name and the parentTechstackId can be null, depending on which the user wants to update.
    val isValid get() = name.isBlank().not() || parentTechstackId != null
}
